import React from "react";
import { useDispatch, useSelector } from "react-redux";
import constants from "../assets/js/constants";
import { setAdditionalClasses } from "../assets/js/utils";
import { toggleLanguage } from "../store/auxiliary/ui/generalSettings";
import useAnimationAppear from "./hooks/useAnimationAppear";
import LanguageToggler from "./LanguageToggler";
import NavbarList from "./NavbarList";
import menuIconPrimary from "../assets/images/menu-primary.png";
import menuIcon from "../assets/images/menu.png";
import useWindowSize from "./hooks/useWindowSize";

function Navbar({
  onPressMenuItem,
  onPressMenuToggler,
  applyAnimationVanishClassName,
  applyAnimationMenuAppearClassName,
  applyStickyNavbarClassName,
  onPressLanguageToggler,
}) {
  const dispatch = useDispatch();
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  const sections = useSelector((state) => state.ui.sections);

  const windowWidth = useWindowSize();
  const applyAnimationAppear = useAnimationAppear();

  // const handleLanguageToggler = () => {
  //   dispatch(toggleLanguage());
  //   if (!generalSettings.rtlLanguage) {
  //     constants.ROOT_ELEMENT.dataset.languageDirection = "right";
  //   } else {
  //     delete constants.ROOT_ELEMENT.dataset.languageDirection;
  //   }
  // };

  return (
    <nav
      className={`navbar  ${setAdditionalClasses(
        ["animate-navbar-appear", "animate-navbar-vanish", "navbar-sticky"],
        [
          applyAnimationMenuAppearClassName || applyAnimationAppear,
          applyAnimationVanishClassName,
          applyStickyNavbarClassName,
        ]
      )}`}
    >
      <div className="navbar__buttons-container">
        {(windowWidth < 1024 || sections.displayContent) && (
          <LanguageToggler
            rtl={generalSettings.rtlLanguage}
            // onPress={handleLanguageToggler}
            onPress={onPressLanguageToggler}
            applyClassName={sections.displayContent ? "border-white" : ""}
          />
        )}
        <div className="menu-icon__container" onClick={onPressMenuToggler}>
          <img
            className="menu-icon"
            src={sections.displayContent ? menuIcon : menuIconPrimary}
            alt=""
          />
        </div>
      </div>
      <NavbarList
        isSticky={applyStickyNavbarClassName}
        onPressMenuItem={onPressMenuItem}
      />
    </nav>
  );
}

export default Navbar;
